// extracted by mini-css-extract-plugin
export default {"container":"Ti-z","blurb":"Ui-z","links":"Vi-z"};